import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";

import { BinIcon } from "../icon/Icon";
import { makeSelectAppKeys } from "../../app/appSelectors";
import { STORE_BUTTON_CONFIG, STORE_BUTTON_TYPES } from './store-button-constants';
import {
    StoreButtonDownloadStyled,
    StoreButtonNameContainerStyled,
    StoreButtonNameStyled,
    StoreButtonStyled,
} from './styled/StoreButtonStyled';
import { Link } from "react-router-dom";
import { RouterPaths } from "../../app/appConstants";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

const LinkComponent = ({children, url, className, onClick}) => url ?
        <StoreButtonStyled href={url} rel="noreferrer" target="_blank" className={className} onClick={onClick}>
            {children}
        </StoreButtonStyled>
        :
        <Link component={StoreButtonStyled} to={RouterPaths.mobileInProgress} className={className} onClick={onClick}>
            {children}
        </Link>

const StoreButton = ({appKeys, type = STORE_BUTTON_TYPES.apple, className, onClick}) => {
    const {getLangPath} = useLangContext();
    const {iconName, title, appStoreKeyName} = STORE_BUTTON_CONFIG[type] || {};
    const url = appKeys[appStoreKeyName] || '';
    return (
            <LinkComponent url={url} className={className} onClick={onClick}>
                <BinIcon name={iconName} style={{fontSize: '48px'}}/>
                <StoreButtonNameContainerStyled>
                    <StoreButtonDownloadStyled>{getLangPath('store_links.download_on')}</StoreButtonDownloadStyled>
                    <StoreButtonNameStyled>{title}</StoreButtonNameStyled>
                </StoreButtonNameContainerStyled>
            </LinkComponent>
    );
};

const mapStateToProps = createStructuredSelector({
    appKeys: makeSelectAppKeys(),
})

export default connect(mapStateToProps)(StoreButton);